<template>
  <section id="store_container">
    <GenericMovement :router-search="routerSearchTable"
                     :router-download="routerDownloadReport"
                     @minute="minutesFront = $event"
                     @data="processDataTable($event)"
                     @download="processDownload($event)">
    </GenericMovement>
    <div v-if="isEnableTable" class="vs-scrollable">
      <template>
        <div class="container" style="height: 600px;overflow: scroll;">
          <h3 class="p-3 text-center">Detalle de la búsqueda</h3>
          <table class="table table-striped table-bordered">
            <thead>
            <tr>
              <th v-for="columns in dataColumns" :key="dataColumns.id">
                <span>
                  {{ columns.columns }}
                </span>
              </th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="dataInfo in dataListFront" :key="dataInfo.id">
              <td v-for="dataNew in dataInfo">
                {{ dataNew.value }}
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </template>
    </div>
    <b-loading :is-full-page="true" v-model="isLoading"></b-loading>
  </section>
</template>

<script>
import {ROUTES} from "@/global/api_routes";
import GenericMovement from "@/views/overview-report/page/generic-movement";

export default {
  name: "index.vue",
  data: () => ({
    routerSearchTable: ROUTES.DASHBOARD.REPORTS.OCCUPATION.DATA_TABLE,
    routerDownloadReport: ROUTES.DASHBOARD.REPORTS.OCCUPATION.DOWNLOAD_REPORT,
    isEnableTable: false,
    dataListFront: [],
    dataColumns: [],
    viewHours: null,
    viewMinutes: null,
    minutes: 0,
    hours: 0,
    isLoading: false,
    minutesFront: 0,
  }),

  methods: {

    /**
     * Método que tiene la logica para pintar la tabla de la data en busqueda
     * @param dataEntry data encontrada de la información
     */
    processDataTable(dataEntry) {
      this.isLoading = true;
      const dataInfoTable = JSON.parse(dataEntry);
      const amount = 1440 / this.minutesFront;
      this.clearObject();
      dataInfoTable.forEach(info => {
        this.buildCellData(info, amount);
      });
      this.buildColumns(amount);
      this.isEnableTable = true;
      this.isLoading = false;
    },

    /**
     * Método que procesa el archivo para que el usuario le de guardar
     * @param file nombre del archivo
     */
    processDownload(file) {
      const a = document.createElement('a');
      const urlFile = process.env.VUE_APP_URL + ROUTES.GLOBAL.DOWNLOAD_FILE + file.info;
      a.href = urlFile;
      document.body.appendChild(a);
      a.download = urlFile;
      a.click();
    },

    /**
     * Método que contruye la celda de la información
     * @param info data encontrada por los criterios
     * @param amount partiones de la de la tabla
     */
    buildCellData(info, amount) {
      const dataList = [];
      /** Primera celda por defecto */
      dataList.push({
        value: info['day_time']
      });
      /** Siguientes columnas hasta amount */
      for (let i = 1; i <= amount; i++) {
        dataList.push({
          value: info['col' + i]
        });
      }
      /** agregar a la lista para mostrar*/
      this.dataListFront.push(dataList);
    },

    /**
     * Método que construye las columnas de la tabla
     * @param amount cantidad de columnas
     */
    buildColumns(amount) {
      /** Primera celda por defecto */
      this.dataColumns.push({
        columns: 'Fecha '
      });
      /** Siguientes columnas hasta amount */
      for (let i = 1; i < amount; i++) {
        if (i === 0) {
          this.roundTime();
          continue;
        }
        this.minutes += this.minutesFront;
        this.calculateTime();
        this.roundTime();
      }
    },

    /**
     * Limpiar tabla
     */
    clearObject() {
      this.dataListFront = [];
      this.dataColumns = [];
      this.minutes = 0;
      this.hours = 0;
    },

    /**
     * Cáclular el time de acuerdo a sus número de columnas
     */
    calculateTime() {
      if (this.minutes >= 60) {
        if (this.minutesFront < 60) {
          this.hours += 1;
          this.minutes = this.minutes % 60;
          return;
        }
        let valueMin = this.minutes;
        while (valueMin >= 60) {
          this.hours = this.hours + 1;
          valueMin -= 60;
        }
        this.minutes = this.minutes % 60;
      }
    },

    /**
     * Redondear el time de la columna
     */
    roundTime() {
      this.viewHours = this.hours;
      this.viewMinutes = this.minutes;
      if (this.hours < 10) {
        this.viewHours = "0" + this.hours;
      }
      if (this.minutes < 10) {
        this.viewMinutes = "0" + this.minutes;
      }
      this.dataColumns.push({
        columns: "<- " + this.viewHours + ":" + this.viewMinutes
      });
    },

  },

  components: {GenericMovement},
}


</script>

<style scoped>

</style>
